var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.441406H20V20.4414H0V0.441406Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2922_2572",
    transform: "scale(0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2922_2572",
    width: 20,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAapJREFUOE+llN1VwkAQhe8AIeSNDogVKB2YDrQCQwXSAVqBxwqACtQKSAnpAKhA3iA/Mp7dzc/uJiJinnJ2Z7+5e2dmCdrH+72PHr2BOxPq92N979x/KgMlzKEVGD6AHbgTXAKVQANG2PwHqoD5YV1AYvTcAHn6CPDTJUqJ030IojmEsq47JqKdTJIls0ugxHkyB3MIxpT6g1ejSNnhBcD0L0o1IIfU95Y/FElaUao/VXHiUoWl0Pb1HJhIVHsIROQMAukf8xB58imv2nOvzoUpoDq8BjAEOCDHi4w1Nq2oEmaZ39anqm3qitYq08MUBFEUIbnyt0i2AuC3Nb8C6iqPdE+u+24lklA4gw/kiYDdFIVpTFQ9erWiHXIek+dtGlDhqbBGTZNI2mipCigPp8kCxA/yQMZBK5QR4YsnYq+t+U2gurq6kgUtZn5Enrc1m9+aKLtJGw/FkZ/0hm/E6/4zYkNhNSUqaA7gTq4RLZAdn0sLrDjzRqfGSPOoDItkMZi2IB6BENr2tCo0PJIPb2cm26bts7z+FWg8Fl3cgugaTEO1zjEcd6mP5jc0rTcUGHmOLgAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon5);
export default __webpack_public_path__ + "static/media/footer-icon5.5f9b10c99a49188b34c98cc0c0315533.svg";
export { ForwardRef as ReactComponent };